import { Component } from '@angular/core';
import { ListEmployeeComponent } from '../employees/list-employee/list-employee';

@Component({
  selector: 'app-admin-employees',
  standalone: true,
  imports: [ListEmployeeComponent],
  templateUrl: './employees-view.html'
})
export class AdminEmployeesView {}
